import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

const useMedia = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" });
  const isTablet = !isMobile && !isDesktop;

  return { isMobile, isDesktop, isTablet, isClient };
};

export default useMedia;
